module.exports = __webpack_public_path__ + "img/verified.881d7d3e.svg";